import {
  GET_CUSTOMER_REQUESTING,
  GET_CUSTOMER_SUCCESS,
  LOGOUT_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOMER_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_CUSTOMER_SUCCESS: {
      const data = action.payload;
      return {
        data,
        isFetching: false
      };
    }
    case LOGOUT_SUCCESS: {
      return {
        ...state,
        data: null
      };
    }
    default:
      return state;
  }
};

export default reducer;
